var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0C11.26 0 5 6.26 5 14C5 22.4153 13.9927 34.0422 17.5635 38.3274C18.322 39.2376 19.678 39.2376 20.4365 38.3274C24.0073 34.0422 33 22.4153 33 14C33 6.26 26.74 0 19 0Z",
    fill: "#FFB45A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.24 22.0002C23.78 22.0002 25.12 20.4002 25.12 18.4002C25.12 16.7202 23.98 15.3402 22.56 15.1202C23.82 14.8602 24.86 13.7402 24.86 12.0602C24.86 10.2802 23.56 8.66016 21.02 8.66016H14V22.0002H21.24ZM16.84 11.0802H20.4C21.36 11.0802 21.96 11.7202 21.96 12.5402C21.96 13.4002 21.36 14.0202 20.4 14.0202H16.84V11.0802ZM16.84 16.4402H20.5C21.62 16.4402 22.22 17.1602 22.22 18.0002C22.22 18.9602 21.58 19.5802 20.5 19.5802H16.84V16.4402Z",
    fill: "#000838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBIcon);
export default __webpack_public_path__ + "static/media/B_Icon.e8f7e02c704b4e98d5b91fed25b36552.svg";
export { ForwardRef as ReactComponent };